<template>
  <div :class="['fee-panel', isFixed ? 'fixed' : '']">
    <div class="segment-list">
      <div v-for="(segmentItem, index) in journeySegments" :key="index">
        <div class="segment-item" v-for="(item, sIndex) in segmentItem.flightSegment" :key="sIndex">
          <div class="trip-type" :style="{ background: segmentItem.journeyType == 2 ? '#FF3122' : '' }">{{segmentItem.journeyType == 1 ? '去程' : '返程'}}</div>
          <DinnerItem :flightItem="item" style="padding-bottom: 10px" />
          <Segment :flightItem="item" showDepDate />
        </div>
      </div>
      
      <el-popover class="popover" ref="pop" placement="top" trigger="click" width="700" @show="popoverShow" v-if="productInfo && Object.keys(productInfo).length">
        <div class="popover-content-wrapper">
          <RefundLuggagesPopoverContent ref="refundPopoverRef" :dataItem="productInfo" :showTips="false" />
          <div v-if="refundTips" class="refund-tips" style="line-height: 25px" v-html="refundTips"></div>
        </div>
        <div class="refund-text" slot="reference">
          <img src="@/assets/warn.png" style="margin: 0 4px 0 0" />
          行李额及退改签规则
        </div>
      </el-popover>
    </div>
    <div class="total-price" v-if="payTotalInfo">
      <div class="price-group">
        <div class="price-item" v-for="(item,index) in payTotalInfo.passengerGroupList" :key="index">
          <div class="type-desc">{{ item.passengerTypeDesc }}</div>
          <div class="detail-row">
            <div class="left-type">机票价格</div>
            <div>￥{{ item.ticketAmount }} * {{ item.count }}</div>
          </div>
          <div class="detail-row">
            <div class="left-type">税费</div>
            <div>￥{{ item.taxAmount }} * {{ item.count }}</div>
          </div>
        </div>
      </div>
      <div class="total-num">¥ {{ payTotalInfo.totalAmount || 0 }}</div>
    </div>
  </div>
</template>

<script>
import Segment from "@/components/Segment.vue";
import DinnerItem from "@/components/DinnerItem.vue";
import RefundLuggagesPopoverContent from "@/components/RefundLuggagesPopoverContent.vue";
import { queryDict } from "@/api/newsapi";

export default {
  name: "IntFeePanel",

  components: { Segment, DinnerItem, RefundLuggagesPopoverContent },

  props: {
    journeySegments: {
      type: Array,
      default: () => []
    },
    payTotalInfo: {
      type: Object,
      default: () => ({})
    },
    productInfo: {
      type: Object,
      default: () => ({})
    },
    isFixed: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      refundTips: ''
    }
  },
  mounted() {
    this.getDicConfigByKey()
  },

  methods: {
    // 解决tab不能正常渲染的问题
    popoverShow() {
      this.$nextTick(() => {
        this.$refs.refundPopoverRef?.setTabsDefault()
        // const refList = this.$refs?.refundPopoverRef || [];
        // refList?.forEach(item => {
        //   item.setTabsDefault();
        // });
      });
    },
    getDicConfigByKey(key = "INT_CHANGE_REFUND_FEE_REMARK") {
      queryDict({ key: key }).then(res => {
        if (res.data) {
          this.refundTips = res.data.replace(/\\n/g, "<br/>");
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>
.fee-panel {
  width: 428px;
  height: fit-content;
  background: #fff;
  border-radius: 8px;
  padding: 16px 16px 0;
  .segment-item {
    margin-bottom: 10px;
    padding-bottom: 15px;
    &:last-of-type {
      padding-bottom: 0;
      border: none;
    }
    .trip-type {
      width: 30px;
      text-align: center;
      background-color: #d70039;
      color: #fff;
      padding: 4px 20px;
      border-radius: 0 8px 8px 0;
    }
  }
  .refund-text {
    display: flex;
    align-items: center;
    padding: 4px;
    font-size: 12px;
    cursor: pointer;
  }
  .total-price {
    padding-top: 20px;
    .price-group {
      .price-item {
        padding: 0 6px;
        .type-desc {
          padding: 6px 0;
          font-size: 14px;
        }
        &:not(:first-child) {
          margin-top: 6px;
        }
      }
      .detail-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 26px;
        font-size: 14px;
        font-weight: 400;
        line-height: 26px;
        color: #4d4e4e;
        padding-left: 16px;
      }
    }
    .total-num {
      font-weight: 700;
      line-height: 60px;
      display: flex;
      justify-content: flex-end;
      font-size: 18px;
      color: #d70039;
      padding: 0 6px;
    }
  }
}
.fee-panel.fixed {
  position: sticky;
  top: 16px;
}

.popover-content-wrapper {
  max-height: 700px;
  overflow-y: auto;
  .seg-item {
    border: 1px solid #dedede;
    border-radius: 8px;
    margin-bottom: 10px;
    overflow: hidden;
    &:last-child {
      margin-bottom: 0;
    }
    .segment {
      background: #eee;
      color: #333;
      font-size: 16px;
      font-weight: bold;
      border-bottom: 1px solid #dedede;
      padding: 8px 0 8px 8px;
    }
  }
}
</style>
